import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; 
import "./css/PerfilAluno.css";
import logo from "../img/logo.png";

const PerfilAluno = () => {
  const [certificados, setCertificados] = useState([]);
  const [cpf] = useState(localStorage.getItem("alunocpf")); 
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCertificados = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/certificados/${cpf}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json", 
          },
        });

        const data = await response.json();

        if (response.ok) {
          setCertificados(Array.isArray(data) ? data : []);
        } else {
          alert(data.erro || "Erro ao carregar certificados.");
        }
      } catch (error) {
        console.error("Erro ao buscar certificados:", error);
        alert("Erro ao buscar certificados.");
      }
    };

    if (cpf) {
      fetchCertificados();
    } else {
      alert("CPF não encontrado!");
      navigate("/"); 
    }
  }, [cpf, navigate]);

 
  const toggleAccordion = (index) => {
    const newCertificados = [...certificados];
    newCertificados[index].isOpen = !newCertificados[index].isOpen; 
    setCertificados(newCertificados);
  };


  const baixarCertificado = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/certificados/${id}/download`, {
        responseType: 'blob', 
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `certificado_${id}.pdf`); 
      document.body.appendChild(link);
      link.click(); 
      document.body.removeChild(link); 
    } catch (error) {
      console.error("Erro ao baixar certificado:", error);
      alert("Erro ao baixar certificado.");
    }
  };

  const handleBackToLogin = () => {
    navigate("/"); 
  };

  return (
    <div className="perfil-aluno-container">
      <div className="perfil-header">
        <img src={logo} alt="Logo" className="logo" />
        <h2>Perfil do Aluno</h2>
      </div>

      <div className="perfil-body">
        <div className="cpf-section">
          <h3>CPF: {cpf}</h3>
        </div>

        <div className="certificados-section">
          <h3>Certificados</h3>
          {certificados.length > 0 ? (
            <ul className="certificados-list">
              {certificados.map((certificado, index) => (
                <li 
                  key={index} 
                  className="certificado-item" 
                  onClick={() => toggleAccordion(index)}  
                >
                  <div className="certificado-header">
                    <h4>{certificado.curso}</h4>
                    <span>{certificado.isOpen ? "▼" : "►"}</span> 
                  </div>

                  {certificado.isOpen && (
                    <div className="certificado-content">
                      <p><strong>Professor:</strong> {certificado.professor}</p>
                      <p><strong>Data de início:</strong> {new Date(certificado.data_inicio).toLocaleDateString()}</p>
                      <p><strong>Data de término:</strong> {new Date(certificado.data_fim).toLocaleDateString()}</p>
                      <p><strong>Carga Horária:</strong> {certificado.carga_horaria} horas</p>
                      <p><strong>Nome do aluno:</strong> {certificado.nome}</p>
                      {certificado.arquivo_certificado ? (
                        <button 
                          className="baixar-btn" 
                          onClick={() => baixarCertificado(certificado.id_certificado)}
                        >
                          Baixar Certificado
                        </button>
                      ) : (
                        <p className="certificado-nao-emisso">Este certificado ainda não foi emitido.</p>
                      )}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <p>Você não possui certificados.</p>
          )}
        </div>
        
        {/* Botão de Voltar à Tela de Login */}
        <button className="btn-voltar" onClick={handleBackToLogin}>
          Voltar para o Login
        </button>
      </div>
    </div>
  );
};

export default PerfilAluno;
